<nz-card class="activity-card shadow-sm border border-gray-200" [class.hide-dots]="!data?.marketingFormId">
  <!-- Header -->
  <div class="flex justify-between items-center mb-2">
    <div class="flex items-center gap-2">
      <div class="font-semibold text-base text-gray-800 flex items-center">
        <span class="border-l-4 border-blue-500 pl-2">市场活动申请</span>
      </div>
    </div>
    <div>
      申请金额 <span class="font-semibold ml-1" style="color: #007BC0;">CNY {{ formatMoney(data.requestedAmount) }}</span>
    </div>
  </div>

  <div class="h-px bg-gray-200 my-3" style="border-top: 1px dashed #ccc;"></div>
  <!-- 申请信息 -->
  <div class="rounded-md mb-3">
    <div class="info-list text-gray-700 text-sm">
      <div class="info-row">
        <span class="label">活动方案：</span>
        <span class="value">{{ data.eventPlanRelease }}</span>
      </div>
      <div class="info-row">
        <span class="label">产品线：</span>
        <span class="value">{{ data.productLine }}</span>
      </div>

      <div class="info-row">
        <span class="label">申请编号：</span>
        <span class="value">{{ data.activityRequestNo }}</span>
      </div>

      <div class="info-row">
        <span class="label">电子签签署完成日期：</span>
        <span class="value">{{ formatDisplayDate(data.esignCompleteTime)}}</span>
      </div>

      <div class="info-row">
        <span class="label">活动举办日期：</span>
        <span class="value">{{ formatDisplayDate(data.eventDate)}}</span>
      </div>

    </div>
  </div>

</nz-card>
<div class="dual-connector" *ngIf="data?.marketingFormId"></div>
<!-- 分割线 -->
<nz-card class="activity-card shadow-sm border border-gray-200" *ngIf="data?.marketingFormId">
  <!-- 核销信息 -->
  <div class="rounded-md mb-3">
    <div class="flex justify-between items-center mb-2">
      <div class="font-semibold text-gray-800">核销信息</div>
      <div class="text-gray-700 text-sm">
        总核销金额
        <span class="font-semibold ml-1" style="color: #007BC0;">
          CNY {{ formatMoney(data?.verificationAmount) }}
        </span>
      </div>
    </div>

    <div class="h-px bg-gray-200 my-3" style="border-top: 1px dashed #ccc;"></div>
    <!-- <div class="h-px bg-gray-200 my-3" style="border-top: 1px dashed #ccc;"></div> -->
    <div class="rounded-md mb-3">
      <div class="flex justify-between text-gray-700 text-sm gap-8">

        <!-- 左列 -->
        <div class="flex-1 info-list">
          <div class="info-row">
            <span class="label">审批状态：</span>
            <!-- <span class="value" *ngIf="data?.approvalStatus">
              <custom-tag [content]="data?.approvalStatus"
                [backgroundColor]="getColorByApprovalStatus(data?.approvalStatus,true,false)"
                [fontColor]="getColorByApprovalStatus(data?.approvalStatus,false,false)"
                [borderColor]="getColorByApprovalStatus(data?.approvalStatus,false,true)"></custom-tag>
            </span> -->

            <span class="value" *ngIf="data.status">
              <custom-tag [content]="data.status" [backgroundColor]="getColorByStatus(data.status,true,false)"
                [fontColor]="getColorByStatus(data.status,false,false)"
                [borderColor]="getColorByStatus(data.status,false,true)"></custom-tag>
            </span>
          </div>

          <div class="info-row">
            <span class="label">核销通过日期：</span>
            <span class="value">{{ formatDisplayDate(data?.verificationDate) }}</span>
          </div>
        </div>

        <!-- 右列 -->
        <div class="flex-1 info-list">
          <!-- <div class="info-row">
            <span class="label">申请状态：</span>
            <span class="value" *ngIf="data.status">
              <custom-tag [content]="data.status" [backgroundColor]="getColorByStatus(data.status,true,false)"
                [fontColor]="getColorByStatus(data.status,false,false)"
                [borderColor]="getColorByStatus(data.status,false,true)"></custom-tag>
            </span>
          </div> -->
          <div class="info-row">
            <span class="label">核销编号：</span>
            <span class="value">{{ data?.verificationCode }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- 分割线 -->
  <div class="h-px bg-gray-200 my-3"></div>

  <!-- 金额与操作按钮 -->
  <div class="amount-box">
    <div class="amount-item">
      <div class="amount-value green">{{ formatMoney(data?.expectedPaymentAmount) }}</div>
      <div class="amount-label">预计付款金额</div>
      <div class="amount-date">预计日期 {{ formatDisplayDate(data?.expectedPaymentDate)}}
      </div>
    </div>
    <div class="divider"></div>
    <div class="amount-item">
      <div class="amount-value blue">{{ formatMoney(data?.actualPaymentAmount) }}</div>
      <div class="amount-label">实际付款金额</div>
      <div class="amount-date">实付日期 {{ formatActualPayDate(data?.actualPaymentDate)}}</div>
    </div>
  </div>

  <!-- 按钮组 -->
  <div class="flex justify-end gap-2 mt-5">
    <button *ngIf="data?.marketFeeInvoices!==null && data?.marketFeeInvoices.length>0" nz-button nzType="text"
      class="func-button flex justify-center" (click)="showModal()">
      查看发票信息
    </button>
    <button [ngStyle]="{ visibility: isAttachmentExist() ? 'visible' : 'hidden' }" nz-button nzType="text" class="func-button flex justify-center"
      (click)="openAttachmentModel()">
      查看附件
    </button>
  </div>
</nz-card>
<nz-modal [(nzVisible)]="isVisible" nzTitle="" [nzFooter]="null" [nzWidth]="'800px'" nzCentered
  (nzOnCancel)="handleCancel()" [nzWrapClassName]="'place-order'">
  <div class="invoice-container" *nzModalContent>
    <h3 class="invoice-title">
      <span class="border-l-4 pl-2" class="invoice-info">发票信息</span>
      <span class="sub">（核销编号{{ data?.verificationCode }}）</span>
    </h3>
    <span class="sub" style="font-weight: bold; margin-bottom: 10px; display: block;">申请类型：{{
      data?.marketingActivityType }}</span>

    <div *ngFor="let item of data?.marketFeeInvoices" class="invoice-card">
      <div class="order-line">
        <span class="label">发票号</span>
        <span class="value bold">{{ item.pkInvoice }}</span>
      </div>
      <div class="info-line">
        <span class="label">发票时间</span>
        <span class="value">{{ formatActualPayDate(item.pkActualPaymentDate) }}</span>

        <span class="label">发票金额</span>
        <span class="value">CNY {{ formatMoney(item.amount) }}</span>

      </div>
    </div>
  </div>
</nz-modal>

<!-- attachment-list-modal.component.html -->
<nz-modal [(nzVisible)]="isAttachmentVisible" [nzFooter]="null" [nzWidth]="'900px'"
  (nzOnCancel)="handleCancelAttachmentModel()">
  <div class="attachment-container" *nzModalContent>
    <h3 class="invoice-title">
      <span class="border-l-4 pl-2" class="invoice-info">附件清单</span>
      <span class="sub">（核销编号{{ data?.verificationCode }}）</span>
    </h3>
    <div class="h-px bg-gray-200 my-3"></div>
    <div class="attachment-list">
      <div class="attachment-item" *ngIf="isAttachmentFileExist(data?.tripartiteAgreement)">
        <div class="title">已盖章的三方协议</div>
        <div class="file-box">
          <a *ngFor="let item of data?.tripartiteAgreement" href="{{item.filePath}}" target="_blank" class="file-link">
            {{item.fileName}}
          </a>
        </div>
      </div>
      <div class="attachment-item" *ngIf="isAttachmentFileExist(data?.adServiceAgreement)">
        <div class="title">已盖章的广告服务协议</div>
        <div class="file-box">
          <a *ngFor="let item of data?.adServiceAgreement" href="{{item.filePath}}" target="_blank" class="file-link">
            {{item.fileName}}
          </a>
        </div>
      </div>
      <div class="attachment-item" *ngIf="isAttachmentFileExist(data?.websiteScreenshot)">
        <div class="title">网站数据截屏</div>
        <div class="file-box">
          <a *ngFor="let item of data?.websiteScreenshot" href="{{item.filePath}}" target="_blank" class="file-link">
            {{item.fileName}}
          </a>
        </div>
      </div>
      <div class="attachment-item" *ngIf="isAttachmentFileExist(data?.salesTargetScreenshot)">
        <div class="title">售出目标达成截屏</div>
        <div class="file-box">
          <a *ngFor="let item of data?.salesTargetScreenshot" href="{{item.filePath}}" target="_blank"
            class="file-link">
            {{item.fileName}}
          </a>
        </div>
      </div>
      <div class="attachment-item" *ngIf="isAttachmentFileExist(data?.eventPhotos)">
        <div class="title">活动现场照片</div>
        <div class="file-box">
          <a *ngFor="let item of data?.eventPhotos" href="{{item.filePath}}" target="_blank" class="file-link">
            {{item.fileName}}
          </a>
        </div>
      </div>
      <div class="attachment-item" *ngIf="isAttachmentFileExist(data?.storePhotos)">
        <div class="title">制作后的营业现场照片</div>
        <div class="file-box">
          <a *ngFor="let item of data?.storePhotos" href="{{item.filePath}}" target="_blank" class="file-link">
            {{item.fileName}}
          </a>
        </div>
      </div>
      <div class="attachment-item" *ngIf="isAttachmentFileExist(data?.dealerSummary)">
        <div class="title">经销商盖章的活动总结</div>
        <div class="file-box">
          <a *ngFor="let item of data?.dealerSummary" href="{{item.filePath}}" target="_blank" class="file-link">
            {{item.fileName}}
          </a>
        </div>
      </div>
      <div class="attachment-item" *ngIf="isAttachmentFileExist(data?.invoiceFile)">
        <div class="title">发票文件路径</div>
        <div class="file-box">
          <a *ngFor="let item of data?.invoiceFile" href="{{item.filePath}}" target="_blank" class="file-link">
            {{item.fileName}}
          </a>
        </div>
      </div>
    </div>
  </div>
</nz-modal>
<nz-modal [(nzVisible)]="modalVisible" [nzTitle]="'REVIEW' | translate" [nzFooter]="modalFooter" [nzWidth]="600"
  [nzContent]="modalContent" (nzOnCancel)="modalVisible = false">
  <ng-template #modalContent>
    <nz-form-item class="my-10">
      <nz-form-label [nzSpan]="3">{{'REASON' | translate}}</nz-form-label>
      <nz-form-control [nzSpan]="21">
        <textarea nz-input [nzRows]="8" [(ngModel)]="comment" maxlength="20" [placeholder]="'PLEASE_INPUT' | translate"
          class="w-full bosch_textarea"></textarea>
      </nz-form-control>
    </nz-form-item>
  </ng-template>


  <!-- 自定义按钮 -->
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancelConfirm()">
      {{ 'CANCEL' | translate }}
    </button>
    <button nz-button nzType="primary" (click)="handleConfirm()">
      {{ (approvalStatus === 'agree' ? 'APPROVE' : 'REJECT') | translate }}
    </button>
  </ng-template>
</nz-modal>